"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mobile = {
  '&$hiddenDesktop': {
    display: 'inline'
  },
  '&$hiddenDesktop$block': {
    display: 'block'
  },
  display: 'none'
};

exports.styles = function (theme) {
  return __assign({
    base: {
      display: 'inline'
    },
    block: {
      display: 'block'
    },
    hiddenDesktop: {
      display: 'none'
    }
  }, mobileStylesHelper_1.default(mobile));
};